module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playout-load-dashboard"
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('line-chart', {
    staticClass: "chart",
    staticStyle: {
      "min-height": "380px"
    },
    attrs: {
      "showLegend": _vm.showLegend,
      "showGridLines": _vm.showLegend,
      "data": _vm.trendData,
      "labels": _vm.labels,
      "xAxeslabelString": 'Quarter Hour Uniques'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8ef9282","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/programmingDashboard/StreamingLoad.vue
// module id = 3392
// module chunks = 3